import { HttpClient } from '@angular/common/http';
import { Component, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RdSiderMenuItem } from '@zs-ca/angular-cd-library';
import {
  LaunchBarApiResponse,
  LaunchBarData,
  UserDetails,
} from './core/models/sider.model';
import { AuthService } from './core/services';
import { CustomIconService } from './core/services/custom-icon.service';

import { ApiEndpoints } from './core/constants/api-endpoints';
import { SOMETHING_WENT_WRONG } from './core/constants/messages';
//import { LaunchBarApiResponse, LaunchBarData, UserDetails } from '@core/models';

import { filter, forkJoin } from 'rxjs';
import { ToasterService } from './core/services/toaster.service';
import { NavMenu } from './core/models/nav-menu.model';
import { CareGapService } from './core/services/care-gap.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  errorMessage = '';

  isLoading = false;

  launchBarData?: LaunchBarData;

  envConstants = environment.config;

  sideBarMenuItemsList: RdSiderMenuItem[] = [];
  navMenuItemList: NavMenu[] = [];
  public isEmbeddedIntoDataFrame: boolean = false;

  @ViewChild('successNotification', { static: false })
  successNotification!: TemplateRef<void>;

  @ViewChild('errorNotification', { static: false })
  errorNotification!: TemplateRef<void>;

  @ViewChild('warningNotification', { static: false })
  warningNotification!: TemplateRef<void>;

  @ViewChild('infoNotification', { static: false })
  infoNotification!: TemplateRef<void>;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private customIconService: CustomIconService,
    private route: ActivatedRoute,
    private router: Router,
    private title: Title, 
    public careGapService: CareGapService
  ) {
    window.addEventListener('message', (event) => {
      // Abort if request doesn't come from a valid origin
      // if (!this.allowedOrigins.includes(event.origin)) return;

      // Log the message contents to the console
      console.log('Data from parent received', event.data);
      if(event.data && event.data.message === 'deeplink_sent') {
        this.careGapService.deeplinkLinks = event.data.data;
        this.careGapService.isDeeplinkModalVisible = true;
      }
    });
    this.customIconService.addCustomIconsToNzLibrary();
  }

  @HostListener('window:onbeforeunload', ['$event'])
  clearLocalStorage(event) {
    localStorage.clear();
  }

  ngOnInit(): void {
    this.isEmbeddedIntoDataFrame = window.self !== window.top ? true : false;
    this.fetchAuthData();
  }
  private fetchAuthData(): void {
    //this.customIconService.addCustomIconsToNzLibrary();
    this.sideBarMenuItemsList = this.auth.getAvailableScreens();
    this.navMenuItemList = this.formNavMenuItems(this.sideBarMenuItemsList);

    this.isLoading = true;
    const launchBar$ = this.http.get<any>(ApiEndpoints.LAUNCH_BAR);

    const user$ = this.http.get<UserDetails>(ApiEndpoints.USER_INFO);
    forkJoin([launchBar$, user$]).subscribe({
      next: ([launchBarResponse, userDetailsResponse]) => {
        if (launchBarResponse?.applications?.length >= 0) {
          this.launchBarData = { ...launchBarResponse };
          if (userDetailsResponse) {
            this.auth.setUserDetails(userDetailsResponse);
            this.sideBarMenuItemsList = this.auth.getAvailableScreens();
          }
        } else {
          this.errorMessage = SOMETHING_WENT_WRONG;
        }
        this.isLoading = false;
      },
      error: (error) => {
        if (error?.status === 401) {
          this.errorMessage = '';
        } else {
          this.errorMessage = SOMETHING_WENT_WRONG;
          this.isLoading = false;
        }
      },
    });
  }

  logout() {
    this.http.get(ApiEndpoints.LOGOUT).subscribe({
      next: (res) => {
        window.location.href = res['logout_url'];
      },
      error: () => {},
    });
  }

  formNavMenuItems(menuItem): Array<NavMenu> {
    this.navMenuItemList =  menuItem.map((item, i) => ({
      children: null,
      isHovered: false,
      key: item.label,
      path: item.path,
      show: true,
      title: item.label
    }));
    return this.navMenuItemList;
  }

  ngOnDestroy() {
    localStorage.clear();
    this.logout();
  }
}
